<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_kerstmis" @click="goToStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/kerstmis/Asset 48.png" alt="">
    <img draggable="false" id="kerstmis_top_image" src="./../../assets/images/kerstmis/Asset 49.png" alt="">
    <img draggable="false" id="tree_image" src="./../../assets/images/kerstmis/Asset 50.png" alt="">
    <img draggable="false" @click="goToOrnament()" class="clickable" id="kerst_start_btn" src="./../../assets/images/Asset 30.png" alt="">

    <span id="kerstmis_start_text">Kerstmis</span>
  </span>
</template>

<script>
export default {
  name: "KerstmisStart",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToStart() {
      this.$router.push('/start');
    },
    goToOrnament() {
      this.$router.push('/kerstmis/ornament');
    },
  },

  computed: {}
};
</script>

<style>
  #kerst_start_btn {
    position: absolute;
    margin-top: 29%;
    left: 19%;
    width: 20%;
  }
  #quit_btn_kerstmis {
    position: absolute;
    margin-top: 29%;
    left: 67%;
    width: 20%;
    z-index: 1;
  }
  #tree_image {
    position: absolute;
    margin-top: 16%;
    left: 28%;
    width: 50%;
  }
  #kerstmis_start_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 11%;
    width: 21%;
    left: 42%;
    color: #1b7537;
    font-size: 4.5vw;
    text-align: center;
    z-index: 1;
    /* -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d); */
    /* filter: drop-shadow(5px 5px 5px #3d3d3d); */
  }

  #kerstmis_top_image {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: -21%;
    width: 112%;
    left: -4%;
    color: #1b7537;
    font-size: 4.5vw;
    text-align: center;
    z-index: 0;
  }
</style>


